/**
 * 博客 用户页面
 */

var slideShare = document.getElementById("slideShare");
var slideHeader = document.getElementById("slideHeader");
var share_cl = document.getElementById("share-close");
slideShare.onclick = function() {
    slideHeader.className = "slideLeft";
};
share_cl.onclick = function() {
    slideHeader.className = "slideRight";
};

window.weiboOpt = {
    source: "手机东方财富网",
    sourceUrl: "http://wap.eastmoney.com/", 
    Appkey: "3050999700",
    RalateUid: "1801487174",
    weibolink: "http://weibo.com/dfcfw"
};

function shareTo(dest) {
    var url = window.shareUrl;
    var cName = "";
    /*sina*/
    var source = weiboOpt.source;
    var sourceUrl = weiboOpt.sourceUrl;
    var sinaAppkey = weiboOpt.Appkey;
    var sinaRalateUid = weiboOpt.RalateUid;

    var title = window.title + "-" + source + "(eastmoney.cn)";

    if (url == null || title == null || url == "" || title == "") {
        alert("错误的链接地址或标题");
        return;
    }
    var shareUrl = "";
    switch (dest.toLowerCase()) {
        case "sina":
            shareUrl = "http://service.weibo.com/share/share.php?url=" + encodeURIComponent(url) + "&appkey=" + sinaAppkey + "&title=" + encodeURIComponent(title) + "&pic=" + encodeURIComponent(pic) + "&ralateUid=" + sinaRalateUid + "&source=" + encodeURIComponent(source) + "&sourceUrl=" + encodeURIComponent(sourceUrl);
            break;
        case "qq":
            shareUrl = "http://v.t.qq.com/share/share.php?url=" + encodeURIComponent(url) + "&appkey=801004939&site=http://wap.eastmoney.com&title=" + encodeURIComponent(title) + "&pic=" + encodeURIComponent(pic);
            break;
        case "qzone":
            shareUrl = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(url) + "&appkey=801004939&site=http://wap.eastmoney.com&title=" + encodeURIComponent(title) + "&desc=&summary=&site=http://wap.eastmoney.com";
            break;
    }
    location.href = shareUrl;
}

$('#header_share_qq').click(function (){
	shareTo('qq');
});
$('#header_share_qzone').click(function (){
	shareTo('qzone');
});
$('#header_share_sina').click(function (){
	shareTo('sina');
});


//////////////////
// WEBPACK FOOTER
// ./dev/channel/blog_user.js
// module id = 0
// module chunks = 2